<mat-card style="text-align: left; margin: 0">
  <mat-card-content style="padding: 20px">
    <div *ngIf="!this.loading && !this.error; else loadingData" class="report-container">
      <div class="report-section">
        <div class="report-section-bar">
          <div class="report-tabs">
            <h3 class="report-section-title">Favourites</h3>
          </div>
        </div>
        <ng-container *ngIf="this.haveFavourites(); else noFavourites">
          <ng-container *ngTemplateOutlet="reportList; context: { $implicit: true }"></ng-container>
        </ng-container>
      </div>
      <div class="report-section">
        <div class="report-section-bar">
          <div class="report-search-container">
            <input-debounce
              [placeholder]="'Search Reports...'"
              [width]="'350px'"
              [fontSize]="'16px'"
              [debounceTime]="275"
              [active]="this.searchString !== ''"
              (searchStringChange)="this.searchReportChange($event)"
            >
            </input-debounce>
          </div>
          <div class="report-tabs">
            <button
              *ngFor="let tab of this.tabs"
              (click)="this.changeTab(tab)"
              [ngClass]="{ active: tab === this.activeTab && this.searchString === '' }"
              class="report-tab-button"
            >
              {{ tab }}
            </button>
          </div>
        </div>
        <ng-container *ngIf="this.haveAnyReports(); else noReports">
          <ng-container *ngTemplateOutlet="reportList; context: { $implicit: false }"></ng-container>
        </ng-container>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<ng-template #noFavourites>
  <div style="padding: 35px 20px; text-align: center">
    You don't currently have any favourite reports.<br />Click the icon
    <mat-icon class="favourite" style="vertical-align: sub">star</mat-icon> on a report to add it as a favourite!
  </div>
</ng-template>

<ng-template #noReports>
  <div style="padding: 35px 20px; text-align: center">No reports found.</div>
</ng-template>

<ng-template #loadingData>
  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 40px">
    <span *ngIf="this.error" style="font-size: 16px">
      {{ this.errorGettingData }}
    </span>
    <div *ngIf="!this.error" style="width: fit-content; font-size: 16px">Loading...</div>
    <mat-progress-bar *ngIf="this.loading" mode="indeterminate"></mat-progress-bar>
  </div>
</ng-template>

<ng-template #reportList let-fav>
  <div class="report-list-container">
    <div *ngFor="let i of this.getMinColCount(fav) | range" class="report-list-col-container">
      <ng-container *ngFor="let report of this.getColItems(fav, i)">
        <ng-container *ngTemplateOutlet="reportItem; context: { $implicit: report }"></ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #reportItem let-report>
  <div class="report-item-container">
    <div class="report-button-container">
      <a href="{{ report.link }}" class="report-button">
        <div class="report-name">
          {{ report.name }}
        </div>
      </a>
      <div class="icon-container">
        <button
          class="report-icon-button"
          (click)="this.handleToggleFavourite('Report', report.favouriteId, report.id)"
        >
          <mat-icon [ngClass]="{ active: report.favouriteId !== null }" class="favourite">star</mat-icon>
        </button>
        <mat-icon
          *ngIf="report.filters.length > 0"
          class="filter"
          [fontIcon]="filterIcon"
          aria-hidden="true"
        ></mat-icon>
      </div>
    </div>
    <div *ngIf="report.filters.length > 0" class="report-saved-filters">
      <div *ngFor="let filter of report.filters" class="filter-container">
        <a href="{{ report.link }}/{{ filter.id }}" class="report-filter-button">
          <div class="filter-name">
            {{ filter.name }}
          </div>
          <div class="filter-created">Created: {{ filter.createdDate | date: this.dateFormat }}</div>
        </a>
        <div class="icon-container">
          <button class="report-icon-button" (click)="this.handleRemoveFilter(filter.id)">
            <mat-icon class="filter-delete" [fontIcon]="clearFilterIcon" aria-hidden="true"></mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
